@if (icon || helper || linkText || label) {
  <tidy-row>
    <div [ngClass]="{'highlight' : highlightLabel}">
      @if (icon) {
        <tidy-image
          [src]="icon"
          class="text-top-align" />
      }
      <tidy-text
        [fieldLabel]="label"
        class="field-label" />
    </div>
    @if (helper) {
      <tidy-text
        [helper]="helper" />
    }
    @if (linkText) {
      <tidy-text
        [body]="' '" />
      <tidy-text
        [body]="linkText"
        class="link"
        (action)="linkAction.emit()" />
    }
  </tidy-row>
}

<div class="radio-group" [class.invalid-field]="!form?.valid" [class.chunk-elements]="!!chunkSize && !sameRow" [class.same-row]="!!chunkSize && sameRow">
  @if (!sameRow) {
    @for (itemGroup of itemsInternal; track itemGroup; let i = $index) {
      <div class="group">
        @for (item of itemGroup; track item; let j = $index) {
          <div class="radio-option" [class.selected]="value === item?.value" [class.has-extra-text]="item?.extraText" (click)="onChange(item)">
            <span class="radio-circle">
              <span class="radio-inner"></span>
            </span>
            <div class="radio-content">
              <div class="radio-label-row">
                <span class="radio-label">{{item?.viewValue | translate}}</span>
                @if (item?.savingsTag) {
                  <span class="savings-tag">{{item.savingsTag | translate}}</span>
                }
              </div>
              @if (item?.extraText) {
                <tidy-text [helper]="item.extraText" class="radio-extra-text" />
              }
            </div>
          </div>
        }
      </div>
    }
  }
  @if (sameRow) {
    @for (item of getVisibleItems(); track item; let i = $index) {
      <div class="radio-option" [class.selected]="value === item?.value" [class.has-extra-text]="item?.extraText" (click)="onChange(item)">
        <span class="radio-circle">
          <span class="radio-inner"></span>
        </span>
        <div class="radio-content">
          <div class="radio-label-row">
            <span class="radio-label">{{item?.viewValue | translate}}</span>
            @if (item?.savingsTag) {
              <span class="savings-tag">{{item.savingsTag | translate}}</span>
            }
          </div>
          @if (item?.extraText) {
            <tidy-text [helper]="item.extraText" class="radio-extra-text" />
          }
        </div>
      </div>
    }
  }
</div>

@if (!showAllItems && hideItemValues?.length) {
  <tidy-row class="field-top-padding">
    <tidy-text
      [body]="'More'"
      (action)="expandOptions()"
      [rippleEffect]="false"
      class="white-link" />
  </tidy-row>
}

@if (selectError) {
  <tidy-error-message
    [text]="selectMessage" />
}

@if (errorMessage && submitted && !form.valid) {
  <tidy-error-message
    [text]="errorMessage" />
}
